import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Confirm, Icon } from "semantic-ui-react";
import { partnerDelete } from "../../../store/actions/partnersActions";
import EditPartner from "./EditPartner";
const PartnersCard = ({ advocate }) => {
  const [editPartner, setEditPartner] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const dispatch = useDispatch();
  return (
    <>
      <div className="card" key={advocate.id}>
        <div className="card-body">
          <div className="user-picture">
            <div
              className="bg-data"
              style={{ background: `url(${advocate.fileURL})` }}
            ></div>
          </div>
          <div className="user-content">
            <div className="with-social-logo">
              <div className="btn-foot">
                {advocate.redirectUrl && (
                  <a
                    href={advocate.redirectUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mr-0"
                  >
                    <Button
                      icon="linkify"
                      color="black"
                      name="RemovePlayerButton"
                    />
                  </a>
                )}
                <Button
                  icon="pencil"
                  color="blue"
                  name="RemovePlayerButton"
                  onClick={() => setEditPartner(advocate)}
                />
                <Button
                  color="red"
                  name="RemovePlayerButton"
                  onClick={() => {
                    setDeleteId(advocate.id);
                  }}
                >
                  <Icon name="minus" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Confirm
        open={deleteId}
        content="You Sure Want To Delete ? You Can't Undo It"
        onCancel={() => {
          setDeleteId(null);
        }}
        onConfirm={() => {
          dispatch(partnerDelete(deleteId));
          setDeleteId(null);
        }}
      />
      <EditPartner
        open={editPartner}
        close={() => setEditPartner(null)}
        partner={editPartner}
      />
    </>
  );
};

export default PartnersCard;
